import React, { useState, useEffect, useRef } from 'react';
import { connect } from 'react-redux';
import {
  getSingleUser,
  deleteSingleUser,
  resetUserForm,
  updateSingleUser,
} from '../../actions/adminUserDash';
import { Helmet } from 'react-helmet';
import moment from 'moment';
import { useHistory, useLocation, useParams } from 'react-router-dom';

const ucFirst = (str: string) =>
  str
    .split(' ')
    .map((w) => w.charAt(0).toUpperCase() + w.slice(1))
    .join(' ');

const infoRowStyle: React.CSSProperties = {
  display: 'flex',
  justifyContent: 'space-between',
  padding: '8px 0',
  borderBottom: '1px solid #f1f1f1',
  fontSize: '0.85rem',
  color: '#202223',
};

const sectionLabelStyle: React.CSSProperties = {
  fontSize: '0.72rem',
  fontWeight: 600,
  color: '#6d7175',
  textTransform: 'uppercase',
  letterSpacing: '0.04em',
};

const fieldLabelStyle: React.CSSProperties = {
  fontSize: '0.72rem',
  fontWeight: 600,
  color: '#6d7175',
  textTransform: 'uppercase',
  letterSpacing: '0.04em',
  display: 'block',
  marginBottom: 4,
};

const inputStyle: React.CSSProperties = {
  width: '100%',
  padding: '7px 10px',
  border: '1px solid #e1e3e5',
  borderRadius: 6,
  fontSize: '0.85rem',
  color: '#202223',
  background: '#fff',
  outline: 'none',
};

const inputDisabledStyle: React.CSSProperties = {
  width: '100%',
  padding: '7px 10px',
  border: '1px solid #e1e3e5',
  borderRadius: 6,
  fontSize: '0.85rem',
  color: '#6d7175',
  background: '#f6f6f7',
  outline: 'none',
};

const SelectedUser = (props: any) => {
  const history = useHistory();
  const location = useLocation();
  const params: any = useParams();

  const [user, setUser] = useState<any>({});
  const [editingInfo, setEditingInfo] = useState(false);
  const [confirmDelete, setConfirmDelete] = useState(false);
  const [showDeleteSuccess, setShowDeleteSuccess] = useState(false);
  const [firstName, setFirstName] = useState('');
  const [lastName, setLastName] = useState('');
  const [email, setEmail] = useState('');
  const [phoneNumber, setPhoneNumber] = useState('');
  const [showUpdateSuccess, setShowUpdateSuccess] = useState(false);
  const [updateClicked, setUpdateClicked] = useState(false);
  const [updateAddressId, setUpdateAddressId] = useState('');
  const [addressReplica, setAddressReplica] = useState<any[]>([]);

  const prevUsersRef = useRef<any>(props.users);

  useEffect(() => {
    const locationState: any = location.state;
    if (locationState === undefined) {
      props.getSingleUser(params.userid);
    }
    if (locationState !== undefined && locationState.user) {
      const u = locationState.user;
      setUser(u);
      setFirstName(u.firstName);
      setLastName(u.lastName);
      setEmail(u.email);
      setPhoneNumber(u.phoneNumber);
      setAddressReplica(u.adress);
    }
    return () => {
      props.resetUserForm();
    };
  }, []);

  useEffect(() => {
    const prevUsers = prevUsersRef.current;
    prevUsersRef.current = props.users;

    if (props.users.user !== prevUsers.user) {
      const u = props.users.user;
      setUser(u);
      setFirstName(u.firstName);
      setLastName(u.lastName);
      setEmail(u.email);
      setPhoneNumber(u.phoneNumber);
      setAddressReplica(u.adress);

      if (updateClicked) {
        setShowUpdateSuccess(true);
        setTimeout(() => {
          setUpdateClicked(false);
          setShowUpdateSuccess(false);
          setEditingInfo(false);
          setUpdateAddressId('');
        }, 3000);
      }
    }

    if (props.users.userDeleted !== prevUsers.userDeleted && props.users.userDeleted) {
      setShowDeleteSuccess(true);
      setTimeout(() => history.push('/adminpanel/users'), 3000);
    }
  });

  const cancelInfoEdit = () => {
    setEditingInfo(false);
    setFirstName(user.firstName);
    setLastName(user.lastName);
    setEmail(user.email);
    setPhoneNumber(user.phoneNumber);
  };

  const updateUserInfo = () => {
    const data: any = {};
    if (user.firstName !== firstName) data.firstName = firstName;
    if (user.lastName !== lastName) data.lastName = lastName;
    if (user.phoneNumber !== phoneNumber) data.phoneNumber = phoneNumber;
    if (user.email !== email) data.email = email;
    if (Object.keys(data).length > 0) {
      setUpdateClicked(true);
      props.updateSingleUser(user._id, data);
    }
  };

  const handleUpdateAddressId = (id: any) => {
    if (!showUpdateSuccess) {
      setUpdateAddressId(updateAddressId === id ? '' : id);
      if (user.adress !== addressReplica) setAddressReplica(user.adress);
    }
  };

  const updateAddress = () => {
    setUpdateClicked(true);
    if (user.adress !== addressReplica) {
      props.updateSingleUser(user._id, { adress: addressReplica });
    }
  };

  const cancelAddressUpdate = () => {
    setUpdateAddressId('');
    setAddressReplica(user.adress);
  };

  const userInfoOnChange = (e: any) => {
    const { name, value } = e.target;
    if (name === 'firstName') setFirstName(value);
    else if (name === 'lastName') setLastName(value);
    else if (name === 'email') setEmail(value);
    else if (name === 'phoneNumber') setPhoneNumber(value);
  };

  const onAddressChange = (e: any, id: any) => {
    setAddressReplica(
      addressReplica.map((a: any) => (a._id === id ? { ...a, [e.target.name]: e.target.value } : a))
    );
  };

  const locationState: any = location.state;

  if (Object.keys(user).length === 0) {
    return (
      <div className="admin-empty-state">
        <i className="fas fa-spinner fa-spin" />
        <p>Loading user…</p>
      </div>
    );
  }

  return (
    <>
      <Helmet>
        <title>
          {locationState?.user
            ? `${locationState.user.firstName} ${locationState.user.lastName}`
            : params.name}{' '}
          - Frozberries Victoria
        </title>
      </Helmet>
    <div style={{ display: 'flex', flexDirection: 'column', gap: 16 }}>
      <div style={{ display: 'grid', gridTemplateColumns: '1fr 280px', gap: 16 }}>
        {/* Left: Info + Addresses */}
        <div style={{ display: 'flex', flexDirection: 'column', gap: 16 }}>
          {/* User info */}
          <div className="admin-card">
            <div className="admin-card-header">
              <p className="admin-card-title">User Information</p>
              {!editingInfo && (
                <button className="admin-dropdown-trigger" onClick={() => setEditingInfo(true)}>
                  <i className="far fa-edit" style={{ marginRight: 4 }} />
                  Edit
                </button>
              )}
            </div>
            <div
              className="admin-card-body"
              style={{ display: 'flex', flexDirection: 'column', gap: 16 }}
            >
              <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 12 }}>
                <div>
                  <label style={fieldLabelStyle}>First Name</label>
                  <input
                    style={editingInfo ? inputStyle : inputDisabledStyle}
                    disabled={!editingInfo}
                    name="firstName"
                    value={firstName}
                    onChange={userInfoOnChange}
                    placeholder="First Name"
                  />
                </div>
                <div>
                  <label style={fieldLabelStyle}>Last Name</label>
                  <input
                    style={editingInfo ? inputStyle : inputDisabledStyle}
                    disabled={!editingInfo}
                    name="lastName"
                    value={lastName}
                    onChange={userInfoOnChange}
                    placeholder="Last Name"
                  />
                </div>
                <div>
                  <label style={fieldLabelStyle}>Email</label>
                  <input
                    style={editingInfo ? inputStyle : inputDisabledStyle}
                    disabled={!editingInfo}
                    name="email"
                    value={email}
                    onChange={userInfoOnChange}
                    placeholder="Email"
                  />
                </div>
                <div>
                  <label style={fieldLabelStyle}>Phone Number</label>
                  <input
                    style={editingInfo ? inputStyle : inputDisabledStyle}
                    type="number"
                    disabled={!editingInfo}
                    name="phoneNumber"
                    value={phoneNumber}
                    onChange={userInfoOnChange}
                    placeholder="Phone Number"
                  />
                </div>
              </div>

              {showUpdateSuccess && updateAddressId === '' && (
                <span
                  className="status-badge confirmed"
                  style={{ fontSize: '0.78rem', alignSelf: 'flex-start' }}
                >
                  Details updated
                </span>
              )}

              {editingInfo && (
                <div style={{ display: 'flex', gap: 8 }}>
                  <button
                    className="admin-dropdown-trigger"
                    style={{ background: '#ec174f', color: '#fff', borderColor: '#ec174f' }}
                    onClick={updateUserInfo}
                  >
                    {props.users.updateButtonLoading ? 'Saving…' : 'Update'}
                  </button>
                  <button className="admin-dropdown-trigger" onClick={cancelInfoEdit}>
                    Cancel
                  </button>
                </div>
              )}
            </div>
          </div>

          {/* Addresses */}
          {user.adress.map((eachAddress: any, index: number) => (
            <div className="admin-card" key={eachAddress._id}>
              <div className="admin-card-header">
                <p className="admin-card-title">
                  {eachAddress.addressType === 'default'
                    ? 'Primary Address'
                    : `Secondary Address ${index}`}
                </p>
                {updateAddressId !== eachAddress._id && (
                  <button
                    className="admin-dropdown-trigger"
                    onClick={() => handleUpdateAddressId(eachAddress._id)}
                  >
                    <i className="far fa-edit" style={{ marginRight: 4 }} />
                    Edit
                  </button>
                )}
              </div>
              <div
                className="admin-card-body"
                style={{ display: 'flex', flexDirection: 'column', gap: 12 }}
              >
                <div>
                  <label style={fieldLabelStyle}>Street</label>
                  <input
                    style={updateAddressId === eachAddress._id ? inputStyle : inputDisabledStyle}
                    disabled={updateAddressId !== eachAddress._id}
                    name="streetAdress"
                    value={addressReplica[index]?.streetAdress || ''}
                    onChange={(e) => onAddressChange(e, eachAddress._id)}
                    placeholder="Street"
                  />
                </div>
                <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 110px', gap: 12 }}>
                  <div>
                    <label style={fieldLabelStyle}>Suburb</label>
                    <input
                      style={updateAddressId === eachAddress._id ? inputStyle : inputDisabledStyle}
                      disabled={updateAddressId !== eachAddress._id}
                      name="suburb"
                      value={addressReplica[index]?.suburb || ''}
                      onChange={(e) => onAddressChange(e, eachAddress._id)}
                      placeholder="Suburb"
                    />
                  </div>
                  <div>
                    <label style={fieldLabelStyle}>State</label>
                    <input style={inputDisabledStyle} disabled value="Victoria" />
                  </div>
                  <div>
                    <label style={fieldLabelStyle}>Post Code</label>
                    <input
                      style={updateAddressId === eachAddress._id ? inputStyle : inputDisabledStyle}
                      disabled={updateAddressId !== eachAddress._id}
                      name="zipCode"
                      value={addressReplica[index]?.zipCode || ''}
                      onChange={(e) => onAddressChange(e, eachAddress._id)}
                      placeholder="Post Code"
                    />
                  </div>
                </div>

                {showUpdateSuccess && updateAddressId === eachAddress._id && (
                  <span
                    className="status-badge confirmed"
                    style={{ fontSize: '0.78rem', alignSelf: 'flex-start' }}
                  >
                    Address updated
                  </span>
                )}

                {updateAddressId === eachAddress._id && (
                  <div style={{ display: 'flex', gap: 8 }}>
                    <button
                      className="admin-dropdown-trigger"
                      style={{ background: '#ec174f', color: '#fff', borderColor: '#ec174f' }}
                      onClick={updateAddress}
                    >
                      {props.users.updateButtonLoading ? 'Saving…' : 'Update'}
                    </button>
                    <button className="admin-dropdown-trigger" onClick={cancelAddressUpdate}>
                      Cancel
                    </button>
                  </div>
                )}
              </div>
            </div>
          ))}

          {/* Orders */}
          <div className="admin-card">
            <div className="admin-card-header">
              <p className="admin-card-title">Orders</p>
            </div>
            {user.orders.length === 0 ? (
              <div className="admin-empty-state">
                <i className="fas fa-shopping-bag" />
                <p>{ucFirst(user.firstName)} hasn't placed any orders yet.</p>
              </div>
            ) : (
              <div className="admin-card-body-flush">
                <div className="table-responsive">
                  <table className="admin-table">
                    <thead>
                      <tr>
                        <th>Time</th>
                        <th>Total</th>
                        <th>Shipping</th>
                        <th>Status</th>
                      </tr>
                    </thead>
                    <tbody>
                      {user.orders.map((order: any) => (
                        <tr
                          key={order._id}
                          onClick={() => history.push({ pathname: `/adminpanel/orders/${order._id}` })}
                          style={{ cursor: 'pointer' }}
                        >
                          <td className="order-time">{moment(order.created_at).fromNow()}</td>
                          <td>AUD {(order.total / 100).toFixed(2)}</td>
                          <td>{ucFirst(order.shippingType)}</td>
                          <td>
                            <span className={`status-badge ${order.orderStatus.toLowerCase()}`}>
                              {order.orderStatus}
                            </span>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
            )}
          </div>
        </div>

        {/* Right: Profile card */}
        <div className="admin-card">
          <div className="admin-card-header">
            <p className="admin-card-title">
              {ucFirst(user.firstName)} {ucFirst(user.lastName)}
            </p>
          </div>
          <div
            className="admin-card-body"
            style={{ display: 'flex', flexDirection: 'column', gap: 0 }}
          >
            <div style={{ ...infoRowStyle, flexWrap: 'wrap', gap: 4 }}>
              <span style={sectionLabelStyle}>Status</span>
              <div style={{ display: 'flex', gap: 4, flexWrap: 'wrap' }}>
                {user.isAdmin && <span className="status-badge confirmed">Admin</span>}
                {!user.isAdmin && !user.registeredUser && (
                  <span className="status-badge cancelled">Guest</span>
                )}
                {!user.isAdmin && !user.isActive && (
                  <span className="status-badge processing">Not Active</span>
                )}
                {!user.isAdmin && user.isActive && (
                  <span className="status-badge confirmed">Active</span>
                )}
              </div>
            </div>
            <div style={infoRowStyle}>
              <span style={sectionLabelStyle}>Marketing</span>
              <span style={{ fontSize: '0.82rem' }}>
                {user.sendOffers ? 'Subscribed' : 'Unsubscribed'}
              </span>
            </div>
            <div style={infoRowStyle}>
              <span style={sectionLabelStyle}>Member since</span>
              <span className="order-time">{moment(user.dateCreated).format('DD MMM YYYY')}</span>
            </div>
            {user.isActive && user.lastLogin !== undefined && (
              <div style={infoRowStyle}>
                <span style={sectionLabelStyle}>Last login</span>
                <span className="order-time">{moment(user.lastLogin).fromNow()}</span>
              </div>
            )}
            <div style={{ ...infoRowStyle, borderBottom: 'none' }}>
              <span style={sectionLabelStyle}>Orders</span>
              <span>{user.orders.length}</span>
            </div>
          </div>
          <div
            className="admin-card-body"
            style={{
              borderTop: '1px solid #f1f1f1',
              display: 'flex',
              flexDirection: 'column',
              gap: 8,
            }}
          >
            {!user.isAdmin && (
              <button
                className="admin-dropdown-trigger"
                onClick={() => props.updateSingleUser(user._id, { isAdmin: true })}
                style={{ width: '100%' }}
              >
                Assign Admin
              </button>
            )}
            {user.isAdmin && (
              <button
                className="admin-dropdown-trigger"
                onClick={() => props.updateSingleUser(user._id, { isAdmin: false })}
                style={{ width: '100%' }}
              >
                Unassign Admin
              </button>
            )}
            {!user.isActive && user.registeredUser && (
              <button
                className="admin-dropdown-trigger"
                onClick={() => props.updateSingleUser(user._id, { isActive: true })}
                style={{ width: '100%' }}
              >
                Activate Account
              </button>
            )}
            {!user.isAdmin && !user.sendOffers && (
              <button
                className="admin-dropdown-trigger"
                onClick={() => props.updateSingleUser(user._id, { sendOffers: true })}
                style={{ width: '100%' }}
              >
                Add to mailing list
              </button>
            )}
            {!user.isAdmin && user.sendOffers && (
              <button
                className="admin-dropdown-trigger"
                onClick={() => props.updateSingleUser(user._id, { sendOffers: false })}
                style={{ width: '100%' }}
              >
                Remove from mailing list
              </button>
            )}

            {!confirmDelete ? (
              <button
                className="admin-dropdown-trigger"
                style={{
                  background: '#f8d7da',
                  color: '#721c24',
                  borderColor: '#f8d7da',
                  width: '100%',
                }}
                onClick={() => setConfirmDelete(true)}
              >
                Delete User
              </button>
            ) : showDeleteSuccess ? (
              <span style={{ fontSize: '0.78rem', color: '#065f46' }}>Deleted. Redirecting…</span>
            ) : (
              <div style={{ display: 'flex', flexDirection: 'column', gap: 6 }}>
                <span style={{ fontSize: '0.78rem', color: '#6d7175' }}>
                  Orders will not be deleted. Are you sure?
                </span>
                <div style={{ display: 'flex', gap: 6 }}>
                  <button
                    className="admin-dropdown-trigger"
                    style={{ background: '#f8d7da', color: '#721c24', borderColor: '#f8d7da' }}
                    onClick={() => {
                      if (!props.users.deleteButtonLoading) props.deleteSingleUser(user._id);
                    }}
                  >
                    {props.users.deleteButtonLoading ? 'Deleting…' : 'Yes, delete'}
                  </button>
                  <button
                    className="admin-dropdown-trigger"
                    onClick={() => setConfirmDelete(false)}
                  >
                    Cancel
                  </button>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>

    </div>
    </>
  );
};

const mapStateToProps = (state: any) => ({
  users: state.users,
});

export default connect(mapStateToProps, {
  getSingleUser,
  deleteSingleUser,
  resetUserForm,
  updateSingleUser,
})(SelectedUser);
